var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "validation-observer",
    { ref: "manualAdjustmentFormRef", attrs: { novalidate: "", tag: "form" } },
    [
      _c("div", { staticClass: "mx-4" }, [
        _c("div", { staticClass: "row mb-3 pt-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("icon-view", {
                attrs: {
                  icon: "fa fa-file-edit",
                  "icon-background": "#bb64c6",
                  "icon-color": "#fff",
                  "icon-size": "14px",
                  title: "Ajuste Manual de Asistencia",
                  variant: "custom-icon-view"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-3 col-sm col-6" },
            [
              _c("validation-provider", {
                attrs: { rules: "required|differentFromZero" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-input", {
                          attrs: {
                            id: "txtAmount",
                            "custom-error-msg": "Debe completar campo",
                            error: errors[0],
                            label: "Ajuste:",
                            "mask-type": "Money",
                            "prepend-icon": "fa fa-dollar-sign",
                            "prepend-icon-left": true,
                            "prepend-icon-type": "success"
                          },
                          model: {
                            value: _vm.model.amount,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "amount", $$v)
                            },
                            expression: "model.amount"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "col-3 col-sm col-12 order-2 order-md-0 order-sm-1 mt-3 mt-md-0 mt-sm-3"
            },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-drop-down", {
                          staticClass: "custom-drop-down",
                          attrs: {
                            id: "ddAdjustmentReasons",
                            "custom-error-msg": "Debe seleccionar una Razón",
                            error: errors[0],
                            fieldkey: "id",
                            fieldname: "name",
                            label: "Razón de Ajuste",
                            options: _vm.reasons
                          },
                          model: {
                            value: _vm.model.reason,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "reason", $$v)
                            },
                            expression: "model.reason"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c("div", { staticClass: "col-6 pl-0 pl-md-5 pl-sm-0 pt-2" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-6" }, [
                _c(
                  "div",
                  {
                    staticClass: "color-secondary-6 font-14 font-weight-normal"
                  },
                  [_vm._v(" Total antes de Ajuste: ")]
                ),
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c(
                    "span",
                    {
                      staticClass:
                        "fa-stack fa-1x color-yellow-star font-14 mr-3"
                    },
                    [
                      _c("em", { staticClass: "fas fa-circle fa-stack-2x" }),
                      _c("em", {
                        staticClass: "fas fa-dollar-sign fa-stack-1x fa-inverse"
                      })
                    ]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "color-green font-26 font-weight-normal",
                      class: _vm.amountClass(_vm.totalAfterAdjustment)
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("price")(_vm.totalAttendedAmount)) +
                          " "
                      )
                    ]
                  )
                ])
              ]),
              _c("div", { staticClass: "col-6" }, [
                _c(
                  "div",
                  {
                    staticClass: "color-secondary-6 font-14 font-weight-normal"
                  },
                  [_vm._v(" Total luego de Ajuste: ")]
                ),
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c(
                    "span",
                    {
                      staticClass:
                        "fa-stack fa-1x color-secondary-30 font-14 mr-3"
                    },
                    [
                      _c("em", { staticClass: "fas fa-circle fa-stack-2x" }),
                      _c("em", {
                        staticClass: "fas fa-dollar-sign fa-stack-1x fa-inverse"
                      })
                    ]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "color-green font-26 font-weight-normal",
                      class: _vm.amountClass(_vm.totalAfterAdjustment)
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("price")(_vm.totalAfterAdjustment)) +
                          " "
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 mt-3" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-text-area", {
                          attrs: {
                            id: "txtComment",
                            "custom-error-msg": "Debe completar campo.",
                            error: errors[0],
                            label: "Comentario:",
                            maxlength: 500,
                            "show-char-count": ""
                          },
                          model: {
                            value: _vm.model.comment,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "comment", $$v)
                            },
                            expression: "model.comment"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mt-3 mt-md-0 mt-sm-3 pb-3" }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 d-flex align-items-center justify-content-md-end justify-content-sm-none"
            },
            [
              _vm.hasManualAdjustment
                ? _c(
                    "action-button",
                    {
                      attrs: {
                        i: "fas fa-trash",
                        variant: "danger btn-cancel danger px-3 mr-2"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onDelete()
                        }
                      }
                    },
                    [_vm._v(" Remover ")]
                  )
                : _vm._e(),
              _c(
                "action-button",
                {
                  attrs: {
                    i: "fas fa-times-circle",
                    variant: "outline-danger btn-cancel danger px-3 mr-2"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onCancel()
                    }
                  }
                },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "action-button",
                {
                  attrs: { i: "fas fa-save", variant: "success px-3" },
                  on: {
                    click: function($event) {
                      return _vm.onConfirm()
                    }
                  }
                },
                [_vm._v(" Guardar ")]
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }